import React, { useState } from 'react';

import { IconClipboardCheck } from '@tabler/icons-react';
import { DroxyModal } from 'components/Droxy/DroxyModal';
import { EvaluationModalGenerateView } from 'pages/ManageSmartAssistant/Sections/EvaluationsSection/EvaluationModal/EvaluationModalGenerateView';
import { EvaluationModalPreviewView } from 'pages/ManageSmartAssistant/Sections/EvaluationsSection/EvaluationModal/EvaluationModalPreviewView';
import { EvaluationModalSelectView } from 'pages/ManageSmartAssistant/Sections/EvaluationsSection/EvaluationModal/EvaluationModalSelectView';
import { useTranslation } from 'react-i18next';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface CreateEvaluationModalProps {
  opened: boolean;
  onClose: () => void;
  smartAssistant: SmartAssistant;
}

export type EvaluationModalView = 'select' | 'generate' | 'preview';

export function CreateEvaluationModal({ opened, onClose, smartAssistant }: CreateEvaluationModalProps) {
  const { t } = useTranslation();
  const [modalView, setModalView] = useState<EvaluationModalView>('select');
  const [generatedQuestions, setGeneratedQuestions] = useState<string[]>([]);

  const handleQuestionsGenerated = (questions: string[]) => {
    setGeneratedQuestions(questions);
    setModalView('preview');
  };

  const handleClose = () => {
    onClose();

    // Wait for the modal to close before resetting the state
    setTimeout(() => {
      setModalView('select');
      setGeneratedQuestions([]);
    }, 500);
  };

  return (
    <DroxyModal
      titleIcon={<IconClipboardCheck />}
      opened={opened}
      onClose={handleClose}
      size="xl"
      title={t('SMART_ASSISTANT.EVALUATIONS_SECTION.CREATE_EVALUATION')}
      description={t('SMART_ASSISTANT.EVALUATIONS_SECTION.CREATE_EVALUATION_DESCRIPTION')}>
      {modalView === 'generate' ? (
        <EvaluationModalGenerateView
          smartAssistantId={smartAssistant._id}
          onGenerated={handleQuestionsGenerated}
          setModalView={setModalView}
        />
      ) : modalView === 'preview' ? (
        <EvaluationModalPreviewView
          smartAssistantId={smartAssistant._id}
          initialQuestions={generatedQuestions}
          setModalView={setModalView}
          onSaveSuccess={handleClose}
        />
      ) : (
        <EvaluationModalSelectView setModalView={setModalView} onClose={handleClose} />
      )}
    </DroxyModal>
  );
}
